<section id="sec1a" class="mission" id="sec1a">
  <div class="container">
    <div class="mission-wrap d-flex justify-content-between align-items-center flex-wrap">
      <div class="mission-content">
        <h3>LIVE WELL.
          <!-- <h3>LIVE WELL. TRAVEL WELL. SHOP WELL. -->
        </h3>
        <p>Our goal is to bring wellness back into your daily life, to make it accessible and easy- not only so that you can feel happy and fulfilled, but so you can also share that happiness with everyone around you. We hope to do this by bringing you the best wellness program, product and travel options from around the world, so you can embark on the wellness journey that you rightly deserve.
        </p>
        <p>Whether you’re looking to get back on track with your workouts, make healthier food choices, finally learn how to meditate or try that yoga pose that your favorite instructor seems to do with ease, we’ve got someone to gently guide you each step of the way. 
        </p>
        <P> If you’re feeling the need to escape from your routine and smell the ocean breeze or hike to a glorious waterfall, to reconnect with yourself and your loved ones, we’ve got the perfect trip for a weekend getaway or for an extended stay.
        </P>
        <p>When you’re needing to bring the gym into your home or give your immune system a little extra boost, we’ve got the products to ensure you can stay healthy wherever you are.
        </p>
      </div>

      <div class="mission-img">
        <div class="mission-img-box">
          <div class="small-img-box zoom">
            <div class="zoom">  <img src="assets/images/yoga-view.jpg" alt="yoga view"> </div>
          </div>
          <div class="large-img-box">
            <div class="zoom"> <img src="assets/images/beach-view.jpg" alt="beach view">  </div>
          </div>
        </div>
        <div class="mission-img-box">
          <div class="large-img-box">
            <div class="zoom">  <img src="assets/images/under-water.jpg" alt="under water"></div>
          </div>
          <div class="small-img-box">
            <div class="zoom">   <img src="assets/images/fancy-pot.jpg" alt="fancy pot"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
